module.exports = __webpack_public_path__ + "img/absolut-age-confirm-bg.5d4568a4.jpg";